
// Core handlers and helpers
let REGISTERED_LIB_LIST = {};
import _HANDLER_CONTENT from './libs/content.js';
REGISTERED_LIB_LIST.HANDLER_CONTENT = _HANDLER_CONTENT;

//Parts
import networkingPart from './parts/networking.js';
import envPart from './parts/env.js';

export default class helpersHandler
{
  constructor(settings={}) {
     this._helpers={};
     let networking_settings={};
     let page_settings = {};
     if(typeof settings === 'object' && settings != null)
     {
        if('_log' in settings && typeof settings._log === 'function')
        {
          this._log = function(type,source,message,data='')
          {
              settings._log(type,'HelperCore::/'+source,message,data);
          }
        }
        if('networking' in settings && typeof settings.networking === 'object')
        {
          networking_settings=settings.networking;
        }
        if('page' in settings && typeof settings.page === 'object')
        {
          page_settings=settings.page;
        }
        if('settings' in settings && typeof settings.settings === 'object')
        {
          this._match={};
          if(Array.isArray(this._settings))
          {
            for(let asetting of this._settings)
            {
              if(asetting.key.startsWith('='))
              {
                this._match[asetting.key.substring(1,asetting.key.length-1)]=asetting.value;
              }
            }
          }
        }
     }
     else
     {
        this._log = function(type,source,message,data='')
        {
          let _message = 'HelperCore::'+source+'- '+message;
          switch(type)
          {
            case "debug":
              console.debug(_message,data);
              break;
            case "warning":
              console.warn(_message,data);
            case "info":
              console.info(_message,data);
              break;
            case "error":
              console.error(_message,data);
              break;
            default:
                console.log(_message,data);
          }
        }
     }
     let _this = this;

     this._helpers._log = function(type,source,message,data='')
     {
       _this._log(type,"parts:"+source,message,data);
     }

     this._helpers.tools={};
     this._helpers.tools.logging=_this._log;
     this._helpers.tools.delaySecAsync = async function(sec){
       return new Promise(function(res)
       {
         _this._log('debug','Waiting for '+sec+' seconds.',sec*1000)
         setTimeout(res, (sec*1000));
       });
     };
     this._helpers.tools.sayHello = function(message){
       this._helpers._log('debug','sayHello',message);
     };
     this._helpers.tools.getTrueForm = function(item,form='')
     {
       if(typeof item === 'string')
       {
          try
          {
            item = JSON.parse(item);
          }
          catch(ex)
          {
            try
            {
              item = JSON.parse(atob(item));
            }
            catch(ex)
            {
              //ok
            }
          }
       }
       if(typeof form === 'string')
       {
         if(form.length>0)
         {
           switch(form)
           {
             case "object":
               if(!typeof item === 'object')
               {
                item={item};
               }
               break;
             case "array":
               if(!Array.isArray(item))
               {
                 item=[item];
               }
               break;
           }
         }
       }
       return item;
     }

     //Setup env
     envPart(this._helpers,page_settings);

     //Setup connection/online status
     networkingPart(this._helpers,networking_settings);

  }

  createContext(context_name)
  {
    let _this = this;
    this._log('debug','createContext','Setting contect to '+context_name+'...');
    return {
      '_log': function(type,source,message,data='')
      {
          _this._log(type,'['+context_name+']HelperCore::/'+source,message,data);
      },
      'has': function(params)
      {
        return _this.has(...params);
      },
      'list': function(params)
      {
        return _this.list(...params);
      },
      'run': function(params)
      {
        return _this.run(...params);
      },
      'runUrlAsync': async function(params)
      {
        return await _this.runUrlAsync(...params);
      },
      'add': function(params)
      {
        return _this.add(...params);
      }
    };
  }

  has(helper,method,throw_mode=false){
    try
    {
      if(helper.length>0 && method.length>0 && !method.startsWith('_'))
      {
        if(helper in this._helpers && typeof this._helpers[helper] === 'object' && method in this._helpers[helper] && typeof this._helpers[helper][method] === 'function')
        {
          return true;
        }
      }
    }
    catch(ex)
    {
      if(throw_mode)
      {
        throw ex;
      }
      else
      {
        this._log('error','has','Has failed!',{'ex':ex,'helper':helper,'method':method,'throw_mode':throw_mode});
      }
    }
    return false;
  }

  list()
  {
    return Object.keys(this._helpers);
  }

  run(helper,method,params,_default=null,error_mode='log')
  {
    try
    {
      if(this.has(helper,method))
      {
        if(!Array.isArray(params))
        {
          params=[params];
        }
        this._log('debug','run','Found '+helper+'.'+method+'()',{'helper':helper,'method':method,'params':params});
        return this._helpers[helper][method](...params);
      }
      else
      {
        this._log('warning','run','Cannot find '+helper+'.'+method+'()!',{'helper':helper,'method':method,'params':params});
        if(typeof _default === 'function')
        {
          return _default();
        }
        else
        {
          return _default;
        }
      }
    }
    catch(ex)
    {
      if(error_mode=='throw')
      {
        throw ex;
      }
      else if(error_mode!=='silent')
      {
        this._log('error','run','Run failed!',ex,{'helper':helper,'method':method,'params':params,'error_mode':error_mode});
      }
    }
  }

  /**
  async _runAsync(helper,method,params,_default=null,error_mode='log'){
    try
    {
      method=method+'Async';
      if(this.has(helper,method))
      {
        if(!Array.isArray(params))
        {
          params=[params];
        }
        this._log('debug','runAsync','Found '+helper+'.'+method+'()',{'helper':helper,'method':method,'params':params});
        return await this._helpers[helper][method](...params);
      }
      else
      {
        this._log('warning','runAsync','Cannot find '+helper+'.'+method+'()!',{'helper':helper,'method':method,'params':params});
        if(typeof _default === 'function')
        {
          return _default();
        }
        else
        {
          return _default;
        }
      }
    }
    catch(ex)
    {
      if(error_mode=='throw')
      {
        throw ex;
      }
      else if(error_mode!=='silent')
      {
        this._log('error','runAsync','Run failed!',ex,{'helper':helper,'method':method,'params':params,'error_mode':error_mode});
      }
    }
  }
  */

  async runUrlAsync(url,_default=null,error_mode='log')
  {
    try
    {
      if(typeof url === 'string')
      {
        let split_point=url.indexOf('//');
        if(split_point>0)
        {
          let path = url.substring(split_point+2);
          split_point=path.indexOf('/');
          if(split_point>0)
          {
            let target=path.substring(0,split_point);
            let params=path.substring(split_point+1);
            params=params.replaceAll("'",'"');
            target = target.split('.');
            if(target.length==2)
            {
              return await this.run(target[0],target[1],this._helpers.tools.getTrueForm(params,'array'),_default,error_mode);
            }
            else
            {
              throw 'Missing helper name or method format: "helper_name.method"';
            }
          }
          else
          {
            throw 'Cannot find / in path="'+path+'"';
          }
        }
        else
        {
          throw 'Cannot find // in url="'+url+'"';
        }
      }
      else
      {
       throw "url is not a string";
      }
    }
    catch(ex)
    {
      if(error_mode=='throw')
      {
        throw ex;
      }
      else if(error_mode!=='silent')
      {
        this._log('error','runUrlAsync','runUrlAsync failed!',{'ex':ex,'url':url,'_default':_default,'error_mode':error_mode});
      }
    }
    return _default;
  }

  add(key,value,option,settings)
  {
    if(!(typeof this._helpers === 'object'))
    {
      throw 'Helpers setup malformed';
    }
    if(!(typeof settings === 'object') || settings==null)
    {
      settings={};
    }
    if(typeof value === 'string')
    {
      try
      {
        let _value = JSON.parse(value);
        if(typeof _value === 'object')
        {
          value=_value;
        }
      }
      catch(ex)
      {
        // Ok leave it as it is then
      }
    }

    if(typeof key === 'string' && key.length>0 && !(key in this._helpers))
    {
      try
      {
        if(typeof option === 'object' && option!=null && ('type' in option))
        {
            let has_action=false;
            if(typeof option.type === 'function')
            {
              this._log('debug','add','Creating helper from function.... '+key+'...',settings);
              this._helpers[key] = option.type({'options':option,'helpers':this,'_log':this._log});
            }
            else if(option.type.toUpperCase() in REGISTERED_LIB_LIST)
            {
              this._log('debug','add','Creating helper from REGISTERED_LIB_LIST '+key+'('+option.type+') ...',settings);
              this._helpers[key] = new REGISTERED_LIB_LIST[option.type.toUpperCase()]({'options':option,'helpers':this,'_log':this._log});
            }

            if(key in this._helpers && typeof this._helpers[key] === 'object' && this._helpers[key]!=null)
            {
              for(let ahelper_setting in settings)
              {
                let ahelper_setting_method = ahelper_setting.split('|');
                let ahelper_method='';
                if(ahelper_setting_method.length==1)
                {
                  ahelper_method=ahelper_setting_method[0];
                }
                else if(ahelper_setting_method.length==2)
                {
                  ahelper_method=ahelper_setting_method[1];
                }
                if( ahelper_method.length>0 && ahelper_method in  this._helpers[key] && typeof this._helpers[key][ahelper_method] === 'function')
                {
                  if(!Array.isArray(settings[ahelper_setting]))
                  {
                    try
                    {
                      settings[ahelper_setting]=JSON.parse(settings[ahelper_setting]);
                    }
                    catch(ex)
                    {
                      settings[ahelper_setting]=[settings[ahelper_setting]];
                    }
                  }
                  this._log('debug','add','Running helper['+key+']['+ahelper_method+']()...',settings[ahelper_setting]);
                  if(this.has(key,ahelper_method))
                  {
                    this.run(key,ahelper_method,settings[ahelper_setting]);
                  }
                  has_action=true;
                }
              }
            }
            else
            {
              this._log('warning','add','Helper.option.type not available.',settings.type);
            }

            if(!has_action)
            {
              return false;
            }
            return true;
        }
        else
        {
           this._log('warning','add','Helper.option or Helper.option.type missing or not available.',settings);
        }
      }
      catch(ex)
      {
        this._log('error','add','Adding helper '+key+' failed!',ex);
      }
    }
    else
    {
      this._log('warning','add','Helper '+key+' already exists or isnt a key!');
    }
    return false
  }

}
